import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomListState } from './custom-list.reducer';

export const selectCustomListState = createFeatureSelector('customList');

export const getCustomList = createSelector(
    selectCustomListState,
    (state: CustomListState) => state?.fields
);
